import { useEffect, useState } from 'react';
import './Footer.scss';

interface PropData {
    data: any,
}

const Footer = (props: PropData) => {
    let res = '';
    let value = '';
    const [data, setData] = useState('');

    useEffect(() => {
        if (props.data) {  
            var data = "<div>";
            var lines = props.data.split("\n")
            for(var line of lines)
            {
                var temp = line.split(" ");
                for(var str of temp)
                {
                    if (str.startsWith('http')) {
                        data += "<a style='color: white !important' href='" + str + "' target='_blank'>" + str + "</a> "
                    } else {
                        data += str + " ";
                    }
                }

                data += "\n";

            }
            data += "</div>"

           
            setData(data)
        }
    }, [props.data])



    return (
        <>
            <div className='footer' dangerouslySetInnerHTML={{ __html: data }} />
        </>
    )
}

export default Footer;